import { CROP_MIN_DELIVERY_DATE } from 'appConstants';
import type { IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import { displayDate } from 'utils';
import * as yup from 'yup';

export default function cropDeliveryDate({ label = '' }: IValidationField) {
  return yup
    .string()
    .label(label)
    .required()
    .default('')
    .isValidDate(t('errors.isInvalidDate', { label }))
    .minDate(
      t('errors.minDateOr', {
        label,
        minDate: displayDate(CROP_MIN_DELIVERY_DATE),
      }),
      CROP_MIN_DELIVERY_DATE,
    );
}
